import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-twitter-old",
  "use": "icon-twitter-old-usage",
  "viewBox": "0 0 32 26",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 26\" id=\"icon-twitter-old\"><path d=\"M10.05,26C22.13,26,28.73,16,28.73,7.33c0-.28,0-.56,0-.84A13.37,13.37,0,0,0,32,3.08a13.32,13.32,0,0,1-3.78,1A6.6,6.6,0,0,0,31.12.49a13.07,13.07,0,0,1-4.17,1.59A6.57,6.57,0,0,0,15.58,6.56a7.25,7.25,0,0,0,.17,1.5A18.65,18.65,0,0,1,2.22,1.2a6.58,6.58,0,0,0,2,8.76,6.65,6.65,0,0,1-3-.82v.09a6.58,6.58,0,0,0,5.26,6.44,6.61,6.61,0,0,1-3,.12,6.57,6.57,0,0,0,6.13,4.56,13.18,13.18,0,0,1-8.16,2.81A12.65,12.65,0,0,1,0,23.07,18.69,18.69,0,0,0,10.05,26\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/twitter-old.svg
// module id = 182
// module chunks = 0 1 2